import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { InviteUserDialogComponent } from 'src/app/shared/components/dialogs';

// TODO: a little bit strange logic
// consider to refactor

@Injectable({
  providedIn: 'root'
})
export class ModalsService {
  constructor(private dialog: MatDialog) {}

  public openInvite(placeholder: string) {
    return this.dialog.open(InviteUserDialogComponent, {
      data: {
        placeholder
      }
    });
  }
}
